import React, { useState, useEffect } from "react";
import StreamResult from "../StreamResult";

const Component = ({ input, transInput, results, selectResultPage }: any) => {
  return <StreamResult source={results} materials={transInput} selectResultPage={selectResultPage} />;
};

export default Component;
